export default {
  LANDING: {
    HEADER: {
      YOU_ARE_COMPANY: 'For employers',
      VIEW_JOB_OFFERS: 'View Job Offers',
    },
    META: {
      TITLE: 'wokap is revolutionizing the&nbsp;job&nbsp;market!',
      TEXT: 'Download the app and find your next job.',
      TEXT_2: 'Get discovered by thousands of top companies!',
    },
    PRIVACY: { META: { TITLE: 'Privacy Policy' } },
    TERMS: { META: { TITLE: 'Terms and Conditions' } },
    DOWNLOAD_APP: { TITLE: 'Get the app' },
    FOOTER: {
      CONTACT: 'Contact us',
      COPYRIGHT: 'All rights reserved © wokap',
      PRIVACY: 'Privacy Policy',
      LEGAL: 'Legal',
    },
  },
} as const;
